module.exports = __webpack_public_path__ + "img/img0.b656f5cc.jpg";